export const knowIssue = [
  {
    issueTitle: "role Section",
    issueDetails:
      "While editing role role scope and role priority cannot be edited at the same time. ",
    issueSeverity: "warning",
  },
];
